import { createContext, useContext, useState, ReactNode } from "react"

type FooterContextType = {
  isFooterVisible: boolean
  toggleFooterVisibility: () => void
}

const FooterVisibilityContext = createContext<FooterContextType | undefined>(undefined)

export function FooterVisibilityProvider({ children }: { children: ReactNode }) {
  const [isFooterVisible, setIsFooterVisible] = useState(true)

  const toggleFooterVisibility = () => {
    setIsFooterVisible((prev) => !prev)
  }

  return (
    <FooterVisibilityContext.Provider
      value={{ isFooterVisible, toggleFooterVisibility }}
    >
      {children}
    </FooterVisibilityContext.Provider>
  )
}

export function useFooterVisibility() {
  const context = useContext(FooterVisibilityContext)

  if (!context) {
    throw new Error(
      "useFooterVisibility debe usarse dentro de FooterVisibilityProvider"
    )
  }

  return context
}